<template>
  <v-card flat
          tile>
    <v-toolbar color="secondary"
               dark
               flat>
      <template v-slot:extension>
        <v-row>
          <v-col>
            <v-text-field clearable
                          flat
                          hide-details
                          prepend-icon="mdi-magnify"
                          solo
                          v-bind:label="$t('search')"
                          v-model="search" />
          </v-col>
        </v-row>
      </template>
      <v-toolbar-title>{{ $t('categories') }}</v-toolbar-title>
    </v-toolbar>
    <v-data-table v-bind:footer-props="{ itemsPerPageOptions: [ 5, 10, 30, 50, 100, -1 ] }"
                  v-bind:headers="headers"
                  v-bind:items="filteredCategories"
                  v-bind:items-per-page="50"
                  v-bind:loading="loading"
                  v-bind:options="{ sortBy: [ 'sort' ] }"
                  v-on:click:row="goToItem">
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    computed: {
      filteredCategories() {
        let filteredCategories = this.categories

        if (this.search != null && this.search.length !== 0) {
          filteredCategories = filteredCategories.filter(f => f.text.toLowerCase().includes(this.search.toLowerCase()))
        }

        return filteredCategories
      },
      headers() {
        return [
          {
            text: this.$t('number'),
            value: 'id'
          },
          {
            text: this.$t('sort'),
            value: 'sort'
          },
          {
            text: this.$t('title'),
            value: 'text'
          }
        ]
      }
    },
    data: () => ({
      search: null
    }),
    methods: {
      goToItem(item) {
        this.$router.push({ name: this.itemRouteName, params: { id: item.id }})
      }
    },
    name: 'CategoryTableCard',
    props: {
      itemRouteName: String,
      loading: Boolean,
      categories: Array,
    }
  }
</script>

<i18n>
  {
    "de": {
      "number": "Nummer",
      "search": "Suche",
      "categories": "Kategorien",
      "title": "Bezeichnung",
      "sort": "Sortierung"
    },
    "en": {
      "number": "Number",
      "search": "Search",
      "categories": "Categories",
      "title": "Title",
      "sort": "Sort"
    }
  }
</i18n>